import { render, staticRenderFns } from "./PaymentStepTwo.vue?vue&type=template&id=b316e786&scoped=true&"
import script from "./PaymentStepTwo.vue?vue&type=script&lang=js&"
export * from "./PaymentStepTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b316e786",
  null
  
)

export default component.exports